// src/services/admin/AdminCityManager.js
import axiosInstance from "../../utils/axiosInstance";

const BASE_URL = "/cities";

const CityManager = {
  /**
   * Fetch all cities.
   * GET /api/admin/cities
   * @returns {Promise<CityDTO[]>}
   */
  async getAllCities() {
    const { data } = await axiosInstance.get(`${BASE_URL}`);
    return data.responseData;
  },

    /**
   * Fetch only active cities along with their active pincodes.
   * GET /api/admin/cities/active
   * @returns {Promise<CityDTO[]>}
   */
    async getActiveCitiesWithPincodes() {
      const { data } = await axiosInstance.get(`${BASE_URL}/active`);
      return data.responseData;
    },

  /**
   * Fetch all pincodes for a city.
   * GET /api/admin/cities/{cityId}/pincodes
   * @param {number} cityId
   * @returns {Promise<CityPincodeDTO[]>}
   */
  async getPincodesByCity(cityId) {
    const { data } = await axiosInstance.get(`${BASE_URL}/${cityId}/pincodes`);
    return data.responseData;
  },

  /**
   * POST /api/admin/cities
   * @param {{ cityName: string, state?: string }} cityDto
   */
  async addCity(cityDto) {
    // Default state to MAHARASHTRA if not provided
    const payload = {
      ...cityDto,
      state: cityDto.state || "MAHARASHTRA",
    };
    const { data } = await axiosInstance.post(
      "/cities",
      payload
    );
    return data.responseData;
  },

  /**
   * Add a new pincode to an existing city.
   * POST /api/admin/cities/{cityId}/pincodes
   * @param {number} cityId
   * @param {{ pincode: string }} cityPincodeDto
   * @returns {Promise<CityPincodeDTO>}
   */
  async addCityPincode(cityId, cityPincodeDto) {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/${cityId}/pincodes`,
      cityPincodeDto
    );
    return data.responseData;
  },

  /**
   * Update active status of a city.
   * PUT /api/admin/cities/{cityId}/status?active=true|false
   * @param {number} cityId
   * @param {boolean} active
   * @returns {Promise<CityDTO>}
   */
  async updateCityStatus(cityId, active) {
    const { data } = await axiosInstance.put(
      `${BASE_URL}/${cityId}/status`,
      null,
      { params: { active } }
    );
    return data.responseData;
  },

  /**
   * Update active status of a pincode.
   * PUT /api/admin/cities/{pinId}/status?active=true|false
   * @param {number} pinId
   * @param {boolean} active
   * @returns {Promise<CityPincodeDTO>}
   */
  async updatePincodeStatus(pinId, active) {
    const { data } = await axiosInstance.put(
      `${BASE_URL}/pincode/${pinId}/status`,
      null,
      { params: { active } }
    );
    return data.responseData;
  },
    /**
   * Delete a city and its associated pincodes.
   * DELETE /api/admin/cities/{cityId}
   * @param {number} cityId
   * @returns {Promise<void>}
   */
    async deleteCity(cityId) {
      await axiosInstance.delete(`${BASE_URL}/${cityId}`);
    },
  
    /**
     * Delete a specific pincode.
     * DELETE /api/admin/cities/pincode/{pinId}
     * @param {number} pinId
     * @returns {Promise<void>}
     */
    async deletePincode(pinId) {
      await axiosInstance.delete(`${BASE_URL}/pincode/${pinId}`);
    },
  
};

export default CityManager;
